import { CardContent } from '@/components/ui/card'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { ToggleSetting } from '@/components/ui/toggle-setting'
import PlanCardShell from '@/components/plan/PlanCardShell'

export default function TerminationCard({
  id, title, description, reference,
  includeInMetrics, onIncludeChange,
  terminatedEarnContributions, onTerminatedEarnChange,
  prorateCompensation, onProrateChange,
  shortTermThresholdDays, onShortTermThresholdChange,
  disabled, variant,
}) {
  return (
    <PlanCardShell id={id} disabled={disabled} variant={variant} title={title} description={description} collapsible={false}>
      <CardContent className="divide-y divide-border">
        {reference}
        <ToggleSetting title="Include terminated employees in metrics" description="Include them in participation rates, averages, and visualizations." checked={includeInMetrics} onCheckedChange={onIncludeChange} />
        <div className="pt-2">
          <ToggleSetting title="Terminated employees earn employer contributions" description="Status controls this rule. When on, records marked Terminated receive employer contributions based on the unified eligibility result. A usable termination date sets the valuation date; otherwise plan-year end is used with a warning." checked={terminatedEarnContributions} onCheckedChange={onTerminatedEarnChange} />
        </div>
        <div className="pt-2">
          <ToggleSetting title="Prorate compensation for partial-year employment" description="ON: enter an annualized salary rate; the calculator scales it for an in-year hire or a record marked Terminated with a valid in-year termination date. OFF: enter actual plan-year or YTD compensation; no date-based scaling occurs." checked={prorateCompensation} onCheckedChange={onProrateChange} />
        </div>
        <div className="flex flex-wrap items-start justify-between gap-x-3 gap-y-1 pt-2">
          <div className="min-w-0 space-y-0.5">
            <span className="block text-sm text-foreground">Short-term termination threshold</span>
            <p className="text-sm text-muted-foreground">Terminations within this many days of hire are flagged in turnover reporting.</p>
          </div>
          <Select value={String(shortTermThresholdDays ?? 90)} onValueChange={(value) => onShortTermThresholdChange(parseInt(value))} disabled={disabled}>
            <SelectTrigger className="w-28" aria-label="Short-term threshold"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="30">30 days</SelectItem>
              <SelectItem value="90">90 days</SelectItem>
              <SelectItem value="180">180 days</SelectItem>
              <SelectItem value="365">365 days</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </CardContent>
    </PlanCardShell>
  )
}
